import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationUI } from 'src/app/model/NotificationUI';
import { SolutionInfo } from 'src/app/model/SolutionInfo';
import { UserInfo } from 'src/app/model/User';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { EventService } from 'src/app/service/event.service';
import { SolutionService } from 'src/app/service/solution.service';
import { Utils } from 'src/app/utils';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';
import { Modal } from '../../controls/modal/modal.service';
import { Tab, TabColor } from '../../controls/tabs/tabs.component';
import { SystemUpdateComponent } from '../../system-update/system-update.component';

export enum NotificationTab {
  GENERAL,
  SYSTEM
}

@Component({
    selector: 'app-notification-panel',
    templateUrl: './notification-panel.component.html',
    styleUrls: ['./notification-panel.component.css'],
    standalone: false
})
export class NotificationPanelComponent implements OnInit {

  solutionInfo: SolutionInfo;
  currentUserAuthInfo: UserInfo;
  notifications: NotificationUI[] = [];
  systemNotifications: NotificationUI[] = [];
  NotificationTab = NotificationTab;
  generalTab = new Tab('General', $localize`General`, undefined, false, "0");
  systemTab = new Tab('System', $localize`System`, 0, false);
  notificationTabs = [this.generalTab, this.systemTab];
  activeTab: NotificationTab = NotificationTab.GENERAL;
  isLoading: boolean = false;
  showNotificationMenu: boolean = false;
  showNotificatiosSettingsMenu: boolean = false;
  maxDisplayGeneral: number = 10;

  TabColor = TabColor;

  solutionInfoSubscription: Subscription;

  @ViewChild("notificationMenuButton")
  notificationMenuButtonObj: ElementRef;
  @ViewChild("notificationMenu")
  notificationMenuObj: ElementRef;

  constructor(private authService: AuthenticationService, 
    private modalRef: ModalRef, 
    private eventService: EventService,
    private solutionService: SolutionService, 
    public modal: Modal, 
    public modalConfig: ModalConfig, 
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.currentUserAuthInfo = this.modalConfig.data.currentUserAuthInfo;
    this.showNotificatiosSettingsMenu = Utils.isAdminRole(this.currentUserAuthInfo);
  }

  ngOnInit(): void {
    this.isLoading = true;

    this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
      this.solutionInfo = newSolutionInfo;
      this.processAllNotifications();
    });

    this.solutionService.getSolutionInfo(this.currentUserAuthInfo.settings.environmentId, this.currentUserAuthInfo.settings.solutionName).pipe(
      tap(resp => {
        this.solutionInfo = resp.body;
        this.processAllNotifications();
        if (this.systemNotifications.length > 0) {
          this.activeTab = NotificationTab.SYSTEM;
          this.systemTab.active = true;
          this.generalTab.active = false;
        }else{
          this.activeTab = NotificationTab.GENERAL;
          this.generalTab.active = true;
          this.systemTab.active = false;
        }
      })
    ).subscribe();

  }

  close(): void {
    this.modalRef.close();
  }

  onSelectedTabChange(selectedIndex: number) {
    this.activeTab = selectedIndex;
  }

  processAllNotifications(): void {
    this.isLoading = true;
    this.notifications = Utils.processNotifications(this.solutionInfo.notificationDetails.notifications);
    this.generalTab.displayCount = this.solutionInfo.notificationDetails.count > 99 ? "99+" : this.solutionInfo.notificationDetails.count.toString();
    this.systemNotifications = Utils.processSystemNotifications(this.solutionInfo, this.currentUserAuthInfo);
    this.systemTab.count = this.systemNotifications.length;
    this.isLoading = false;
  }

  handleNotificationLink(notification: NotificationUI): void{
    if (notification.type == "SYSTEM_UPDATE"){
      if (this.activatedRoute.firstChild.component !== SystemUpdateComponent){
        Utils.handleNotificationLink(notification, this.router, this.modal, this.eventService);
      }
    } else {
      Utils.handleNotificationLink(notification, this.router, this.modal, this.eventService);
    }
  }

  //user menu
  toggleNotificationMenu(): void {
    setTimeout(() => {
      this.showNotificationMenu = !this.showNotificationMenu;
    }, 0);
  }

  onKeyToggleNotificationMenu(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.showNotificationMenu = false;
    }
  }

  goToMoreNotifications(): void{
    this.router.navigate(['/activities/notifications']);
    this.close();
  }

  goToSettingsNotifications(): void{
    this.router.navigate(['/settings/notifications']);
    this.close();
  }

  @HostListener("document:click", ["$event"])
  clickout(event: any) {
    if (this.notificationMenuObj.nativeElement.classList.contains("ot-dropdown--is-active") && !this.notificationMenuButtonObj.nativeElement.contains(event.target)){
      this.toggleNotificationMenu();
    }
  }
}
